import Util from '../../../../shared/util/util';
import SaveReportAs from '../../../../../mutations/reporting/SaveReportAsMutation';
import {createToast} from '../../../../shared/components/toasts/another-toast/toaster';
import {MODAL_TYPE, showModal} from '../../../../shared/components/modals/generic_modal_conductor';
import type {SaveReportAsInput} from '../../../../../mutations/reporting/__generated__/SaveReportAsMutation.graphql';
import {IntlShape} from 'react-intl';

const saveReportAsMutation = (
	intl: IntlShape,
	closeModal: () => void,
	callback: () => void,
	report: SaveReportAsInput
): void => {
	const onSuccess = () => {
		createToast({
			duration: 5000,
			message: intl.formatMessage({id: 'common.action.saved'}, {entity: report.name}),
		});
		closeModal();
		if (callback && callback instanceof Function) {
			callback();
		}
	};
	Util.CommitMutation(SaveReportAs, report, onSuccess);
};

export const saveReportAs = (intl: IntlShape, report: SaveReportAsInput, callback: () => void): void => {
	showModal({
		report: report,
		type: MODAL_TYPE.SAVE_REPORT_AS_MODAL,
		saveReportAs: (closeModal: () => void, saveReportAs: SaveReportAsInput) =>
			saveReportAsMutation(intl, closeModal, callback, saveReportAs),
	});
};
